// Namespaces
import { ProposalDAOInterface } from '../ProposalDAO';
import { ComparisonItemBasedProposalDAO } from '../ProposalDAOImpl';
import { ComparisonItemDAO } from '../ProposalItemDAO';
import * as ProposalNS from '../../Proposal';
import * as ProposalElementNS from '../../ProposalElements';
import { ProposalFieldDAO } from '../ProposalFieldDAO';
import { ProposalStyleClassNames } from '../../ProposalStyleClassNames';
import PlanningAssetAllocationValue from '@/types/planning-asset-allocation-value';
import PlanningAssetAllocationCell from '@/views/components/proposals/grid-elements/PlanningAssetAllocationCell';

export default class PlanningAssetAllocationDAO extends ComparisonItemBasedProposalDAO {
  public static buildInstance(proposal: ProposalNS.Proposal, proposalElement: ProposalElementNS.ProposalDataElement): ProposalDAOInterface {
    return new PlanningAssetAllocationDAO(proposal, proposalElement);
  }

  /* eslint-disable-next-line class-methods-use-this */
  protected getColorKeys(): string[] {
    return [];
  }

  protected async build(): Promise<void> {
    let itemDAO: ComparisonItemDAO | null = null;
    while ((itemDAO = this.nextItem()) !== null) {
      const { planning } = itemDAO.item;

      if (planning) {
        const { planAccount, planAccountId } = planning;

        this.addPlanningPlanningAssetAllocationField(itemDAO, '', { planAccountId, planAccount, comparisonItem: itemDAO.item, user: this.proposal.appUser });
      }
    }
  }

  private addPlanningPlanningAssetAllocationField(itemDAO: ComparisonItemDAO, name: string, value: PlanningAssetAllocationValue): PlanningAssetAllocationValue {
    const field: ProposalFieldDAO = new ProposalFieldDAO(name, value, ProposalStyleClassNames.ProposalTableContent);
    field.cellType = PlanningAssetAllocationCell;
    field.decimalPlace = 2;
    this.addFieldDAO(itemDAO, field);
    return value;
  }
}
